<script>
    import {writable} from "svelte/store";
    import DOMPurify from "dompurify";
    import {onMount} from "svelte";

    export let id = '';

    const messages = [];
    let currentIndex = 0;
    const message = writable('');

    export function addMessage(key, htmlMessage) {
        const index = messages.findIndex(msg => msg.key == key);

        if (index == -1) {
            messages.push({
                key: key,
                message: htmlMessage
            });
        }
    }

    export function removeMessage(key) {
        const index = messages.findIndex(msg => msg.key == key);

        if (index !== -1) {
            messages.splice(index, 1);
        }
    }

    export function clearMessages() {
        messages.length = 0;
    }

    function nextMessage() {
        if (messages.length == 0) {
            return '';
        }

        currentIndex = (currentIndex + 1) % messages.length;
        return messages[currentIndex].message;
    }

    onMount(() => {
        DOMPurify.addHook('uponSanitizeAttribute', function(node, attr) {
            if (node.tagName && node.tagName.toLowerCase() === 'a' && node.hasAttribute('target')) {
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
    });

    onMount(() => {
        setInterval(() => {
            message.set(nextMessage());
        }, 3000);
    });
</script>

<div {id} class="top-bar ellipsis {$$props.class}" role="status">
    {#if $message}
        {@html DOMPurify.sanitize($message, {ADD_ATTR: ['target']})}
    {/if}
</div>


<style>
    .top-bar {
        padding-left: var(--brak-site-padding);
        padding-right: var(--brak-site-padding);
        height: var(--brak-top-bar-height);
        line-height: var(--brak-top-bar-height);
        text-align: center;
    }

    .top-bar:empty {
        display: none;
    }

    .top-bar :global(.full-bar-link) {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        height: 100%;
    }
</style>